// Phase 2 V7 (Apr 19 2026) — HTTP client for user custom voices.
// Pattern mirrors videoDraftService.ts — all calls wrapped in handleApi().
import { axiosInstanceWebsite } from "@/services/instance";
import { handleApi } from "@/utils/handleApi";
import type {
  CreateCustomVoiceRequest,
  CustomVoiceResponse,
  PreviewCustomVoiceRequest,
  PreviewCustomVoiceResponse,
  UpdateCustomVoiceRequest,
} from "./videoDraft.types";

const BASE = "/ads/videos/voices/custom";

export function previewCustomVoice(payload: PreviewCustomVoiceRequest) {
  return handleApi(
    axiosInstanceWebsite
      .post<PreviewCustomVoiceResponse>(`${BASE}/preview`, payload)
      .then((r) => r.data)
  );
}

export function createCustomVoice(payload: CreateCustomVoiceRequest) {
  return handleApi(
    axiosInstanceWebsite
      .post<CustomVoiceResponse>(BASE, payload)
      .then((r) => r.data)
  );
}

export function listCustomVoices() {
  return handleApi(
    axiosInstanceWebsite
      .get<CustomVoiceResponse[]>(BASE)
      .then((r) => r.data)
  );
}

export function renameCustomVoice(id: string | number, payload: UpdateCustomVoiceRequest) {
  return handleApi(
    axiosInstanceWebsite
      .patch<CustomVoiceResponse>(`${BASE}/${id}`, payload)
      .then((r) => r.data)
  );
}

export function deleteCustomVoice(id: string | number) {
  return handleApi(
    axiosInstanceWebsite.delete<void>(`${BASE}/${id}`).then(() => undefined)
  );
}
